import { Box, Table, TableHead, TableBody, TableCell, TableContainer } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { primaryColor } from "../../utils/theme";

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[200]}`,
  overflowX: 'auto',
  boxShadow: 'none',
  marginBottom: theme.spacing(4),
}));

export const StyledTable = styled(Table)({
  borderCollapse: 'separate',
  borderSpacing: 0,
});

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: '#5f847d',

  '& th': {
    backgroundColor: '#5f847d',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.85rem',
    borderBottom: 'none',
    padding: theme.spacing(1.5, 2),
  },
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  '& tr:last-child td': {
    borderBottom: 0,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '0.85rem',
  color: theme.palette.custom.sidebarText,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(1.5, 2),
}));

interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | 'generated' | 'paid' | string;
}

export const StatusTag = styled(Box)<StatusTagProps>(({ theme, status }) => {
  let bgColor: string;
  let color: string;

  switch (status) {
    case 'Active':
    case 'Completed':
    case 'generated':
      bgColor = alpha(primaryColor, 0.15);
      color = primaryColor;
      break;
    case 'paid':
      bgColor = alpha(theme.palette.success.main, 0.15);
      color = theme.palette.success.main;
      break;
    case 'unpaid':
      bgColor = alpha(theme.palette.error.main, 0.15);
      color = theme.palette.error.main;
      break;
    case 'Partially Paid':
      bgColor = alpha(theme.palette.warning.light, 0.5);
      color = theme.palette.warning.dark;
      break;
    case 'Pending':
      bgColor = alpha(theme.palette.warning.light, 0.5);
      color = theme.palette.warning.dark;
      break;
    case 'Cancelled':
      bgColor = alpha(theme.palette.error.main, 0.15);
      color = theme.palette.error.main;
      break;
    case 'Upcoming':
      bgColor = alpha(theme.palette.link.main, 0.15);
      color = theme.palette.link.main;
      break;
    default:
      bgColor = theme.palette.grey[100];
      color = theme.palette.grey[600];
  }

  return {
    backgroundColor: bgColor,
    color: color,
    fontWeight: 600,
    fontSize: '0.75rem',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '4px',
    textAlign: 'center',
    width: 'fit-content',
    // float: "left", // Removed float as it might interfere with flex layouts
    // margin: "0 auto", // Removed specific margins to let parent control layout
  };
});
